const config = {
  apiKey: 'AIzaSyBVWVe-QXPF3fFRHOjrJpUCdu9VGP5xt6U',
  authDomain: 'rai-disputa.firebaseapp.com',
  projectId: 'rai-disputa',
  storageBucket: 'rai-disputa.firebasestorage.app',
  messagingSenderId: '659999683650',
  appId: '1:659999683650:web:679ace3da6af7caef529db',
  measurementId: 'G-0XTLHYB168',
};

export default config;
